import { decodeToken } from "react-jwt";

// const crypto = require('crypto');

// const secretKey = 'your-256-bit-secret';



// function base64UrlEncode(str) {
//   return Buffer.from(str)
//     .toString('base64')   // Base64'e çevir
//     .replace(/\+/g, '-')  // '+' karakterini '-' ile değiştir
//     .replace(/\//g, '_')  // '/' karakterini '_' ile değiştir
//     .replace(/=+$/, '');  // "=" karakterini kaldır
// }

// // Header kısmını oluştur
// const header = {
//   alg: 'RS256', // HMAC SHA256 algoritması
//   typ: 'JWT'
// };

// // Payload kısmını oluştur
// // const payload = {
// //   sub: '1234567890',
// //   name: 'John Doe',
// //   iat: Math.floor(Date.now() / 1000)  // current time
// // };

// // Base64'e kodla

// function asciiEncode (inputText) {
//   const encodedHeader = base64UrlEncode(JSON.stringify(header));
//   const encodedPayload = base64UrlEncode(JSON.stringify(inputText));
//   const signatureBase = `${encodedHeader}.${encodedPayload}`;

//   const signature = crypto
//   .createHmac('sha256', secretKey)
//   .update(signatureBase)
//   .digest('base64')  // Base64 formatında imzalama
//   .replace(/\+/g, '-')  // URL-safe base64 kodlama
//   .replace(/\//g, '_')  // URL-safe base64 kodlama
//   .replace(/=+$/, '');
//   const jwtToken = `${encodedHeader}.${encodedPayload}.${signature}`;
//   return jwtToken;

// }

function asciiDecode(inputText) {
  // if (inputText) {
  //   const splitPre = inputText.split(".")[0];
  //   const splitData = inputText.split(".")[1];
  //   const splitPost = inputText.split(".")[2];
  //   const prefix = splitData.slice(0, 2);
  //   const postfix = splitData.slice(12);
  //   const selectedChars = splitData.slice(2, 12);

  //   // ASCII değerlerini bir azalt
  //   const decodedChars = selectedChars
  //     .split("")
  //     .map((char) => String.fromCharCode(char.charCodeAt(0) - 1))
  //     .join("");

  //   return decodeToken(
  //     `${splitPre}.${prefix}${decodedChars}${postfix}.${splitPost}`
  //   );
  // }
  if (inputText) {
    const preData = inputText.split(".")[0];
    const middleData = inputText.split(".")[1];
    const postData = inputText.split(".")[2];

    const oncesi = middleData.substring(0, 2);
    const kendi = middleData.substring(2);
    let ekendi = "";

    for (let i = 0; i < kendi.length; i++) {
      if (kendi[i] === ".") {
        ekendi += kendi[i]; // Nokta olduğu gibi eklenir
      } else {
        let newChar;
        if (i % 2 === 0) {
          newChar = String.fromCharCode(kendi.charCodeAt(i) - 1); // Çift indeksler için 1 azalt
        } else {
          newChar = String.fromCharCode(kendi.charCodeAt(i) + 1); // Tek indeksler için 1 artır
        }
        ekendi += newChar; // Çözülen karakteri sonuca ekle
      }
    }

    const Tp = decodeToken(`${preData}.${oncesi}${ekendi}.${postData}`);
    return Tp;
  }
  return "";
}

export default  asciiDecode ;
